import { ContentType, Payload } from 'recharts/types/component/DefaultLegendContent';
import styled from 'styled-components';

import { Shapes } from '@components/shapes';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { Color, theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

const BORDER_RADIUS_PX = 4;

export interface LegendPayload extends Payload {
  payload?: {
    color?: Color;
    strokeDasharray: string | number;
    value?: string | number;
  };
}

export const renderLegend: ContentType = ({ payload }) => {
  if (!payload || payload.length === 0) return null;

  return (
    <Stack
      orientation="horizontal"
      space={6}
      align="center"
      justify="flex-end"
      style={{ marginBottom: pxToRem(24) }}
    >
      {payload.map((entry: LegendPayload, index) => (
        <Stack orientation="horizontal" align="center" space={1} key={`item-${index}`}>
          <Shapes.Circle color={entry.payload?.color} size={12} />
          <Text font="semibold14" color="textSecondary" text={entry.value} />
        </Stack>
      ))}
    </Stack>
  );
};

export const RootContainer = styled.div<{ $height: number }>((p) => ({
  width: '100%',
  height: pxToRem(p.$height),
  position: 'relative',
}));

export const TitleContainer = styled.div({
  position: 'absolute',
  top: pxToRem(16),
  left: pxToRem(16),
  zIndex: 1,
});

export const TooltipContainer = styled.div({
  backgroundColor: theme.color.indigo100,
  border: `1px solid ${theme.color.indigo100}`,
  borderRadius: pxToRem(BORDER_RADIUS_PX),
  padding: pxToRem(16),
  boxShadow: theme.shadow.medium,
});
